import * as types from "../actions/types";

const sameNodes = (n1, n2) => n1[0] === n2[0] && n1[1] === n2[1];

const sameSegments = (s1, s2) => {
  if (
    s1[0] === s2[0] &&
    s1[1] === s2[1] &&
    s1[2] === s2[2] &&
    s1[3] === s2[3]
  ) {
    return true;
  }
  if (
    s1[0] === s2[2] &&
    s1[1] === s2[3] &&
    s1[2] === s2[0] &&
    s1[3] === s2[1]
  ) {
    return true;
  }
  return false;
};

const initialState = { selected: null, segments: [] };

const toggleSegment = (state, payload) => {
  const newSegment = [...state.selected, ...payload];
  const removedSegment = state.segments.findIndex(segment =>
    sameSegments(segment, newSegment)
  );
  if (removedSegment !== -1) {
    return {
      selected: null,
      segments: [
        ...state.segments.slice(0, removedSegment),
        ...state.segments.slice(removedSegment + 1)
      ]
    };
  }
  return {
    selected: null,
    segments: [...state.segments, newSegment]
  };
};
export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SELECT_NODE:
      if (!state.selected) {
        return {
          ...state,
          selected: payload
        };
      }
      if (sameNodes(state.selected, payload)) {
        return {
          ...state,
          selected: null
        };
      }

      return toggleSegment(state, payload);

    case types.REMOVE_TRACE:
      return initialState;

    case types.SELECT_MODELE:
      return initialState;

    default:
      return state;
  }
};
